import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { Timesheet } from 'src/app/models/Timesheet';

import { FetchTimesheets } from '../timesheets.actions';
import { TimesheetsService } from '../timesheets.service';
import { TimesheetState } from '../timesheets.state';
import { TimeslotListService } from '../timeslot-list.service';

@Component({
    selector: 'app-timeslot-list',
    templateUrl: './timeslot-list.component.html',
    styleUrls: ['./timeslot-list.component.scss'],
    providers: [TimeslotListService],
})
export class TimeslotListComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    public sortedTimeslots: any[] = [];

    @Select(TimesheetState.timesheets) timesheets$: Observable<Timesheet[]>;
    @Input() timesheet: Timesheet;
    @Input() isEditable: boolean = true;

    @Output() changeEvent: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private store: Store,
        private logger: NGXLogger,
        private timeslotListService: TimeslotListService,
        // Next imports are required in timeslotService, please don't remove them
        private modalService: NgbModal,
        private toastr: ToastrService,
        private timesheetsService: TimesheetsService, // Last import
    ) {}

    ngOnChanges() {
        this.sortTimeslots();
    }
    
    ngOnInit(): void {
        this.logger.debug('Fetching timesheets');
        this.subscriptions.add(
            this.store.dispatch(new FetchTimesheets()).subscribe((state) => {
                if (state.timesheet.timesheets && state.timesheet.timesheets != this.timesheet) {
                    this.timesheets$.subscribe((ts) => {
                        ts.forEach((el) => {
                            if (this.timesheet.uuid === el.uuid) {
                                this.timesheet = el;
                            }
                        });
                    });
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

      sortTimeslots() {
        if (this.timesheet && this.timesheet.timeslots) {
        // Sorteer de array op basis van de projectnaam
        this.sortedTimeslots = [...this.timesheet.timeslots].sort((a, b) => {
            const projectA = a.project.title.toUpperCase();
            const projectB = b.project.title.toUpperCase();
            if (projectA < projectB) {
            return -1;
            }
            if (projectA > projectB) {
            return 1;
            }
            // Projectnamen zijn gelijk
            return 0;
        });
        }
    }

    openAddTimeslotModal = this.timeslotListService.openAddTimeslotModal;
    openEditTimeslotModal = this.timeslotListService.openEditTimeslotModal;
    removeTimeslot = this.timeslotListService.removeTimeslot;
    getBase64 = this.timeslotListService.getBase64;
    getFileName = this.timeslotListService.getFileName;
}
